/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Leavereview2Inputs */

const id_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggalkan ulasan`)
};

const ms_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggalkan ulasan`)
};

const da_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv en anmeldelse`)
};

const de_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung hinterlassen`)
};

const en_us2_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave a review`)
};

const es_es2_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja una reseña`)
};

const es_mx2_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja una reseña`)
};

const fil_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-iwan ng review`)
};

const fr_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laisser un avis`)
};

const it_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia una recensione`)
};

const hu_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Értékelés írása`)
};

const nl_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een review achterlaten`)
};

const no_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legg igjen en omtale`)
};

const pl_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napisz recenzję`)
};

const pt_br2_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe um comentário`)
};

const pt_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar uma avaliação`)
};

const ro_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasă o recenzie`)
};

const fi_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jätä arvostelu`)
};

const sv_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lämna en recension`)
};

const vi_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để lại đánh giá`)
};

const tr_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorum bırak`)
};

const cs_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napsat recenzi`)
};

const bg_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставете ревю`)
};

const ru_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Написать обзор`)
};

const uk_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Залишити відгук`)
};

const ar_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اترك مراجعة`)
};

const hi_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा लिखें`)
};

const th_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เขียนรีวิว`)
};

const ja_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビューを書く`)
};

const zh_cn2_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发表评论`)
};

const zh_hant1_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`發表評論`)
};

const ko_offerdetail_reviews_leavereview2 = /** @type {(inputs: Offerdetail_Reviews_Leavereview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리뷰 작성`)
};

/**
* | output |
* | --- |
* | "Leave a review" |
*
* @param {Offerdetail_Reviews_Leavereview2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_leavereview2 = /** @type {((inputs?: Offerdetail_Reviews_Leavereview2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Leavereview2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_leavereview2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_leavereview2(inputs)
	if (locale === "da") return da_offerdetail_reviews_leavereview2(inputs)
	if (locale === "de") return de_offerdetail_reviews_leavereview2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_leavereview2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_leavereview2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_leavereview2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_leavereview2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_leavereview2(inputs)
	if (locale === "it") return it_offerdetail_reviews_leavereview2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_leavereview2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_leavereview2(inputs)
	if (locale === "no") return no_offerdetail_reviews_leavereview2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_leavereview2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_leavereview2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_leavereview2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_leavereview2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_leavereview2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_leavereview2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_leavereview2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_leavereview2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_leavereview2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_leavereview2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_leavereview2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_leavereview2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_leavereview2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_leavereview2(inputs)
	if (locale === "th") return th_offerdetail_reviews_leavereview2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_leavereview2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_leavereview2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_leavereview2(inputs)
	return ko_offerdetail_reviews_leavereview2(inputs)
});
export { offerdetail_reviews_leavereview2 as "offerDetail.reviews.leaveReview" }